module.exports = __webpack_public_path__ + "51c42951eb07df9b4b545d089f2f506a.svg";